// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-header .title[data-v-60641b38]{margin-left:-15px}.card-body[data-v-60641b38]{padding-top:0!important}.result-row[data-v-60641b38]{padding-top:18px}.circle-container[data-v-60641b38]{color:#fff;height:30px;width:30px}.divider[data-v-60641b38]{border:1px solid #f4f2f3;height:33px;margin:0 14px;width:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
